import { Config } from "../../_config/index.js"
import { UseCase } from "../../_kernel/architecture.js"
import { GetConfigProjectService } from "../Services/GetConfigProjectService.js"
import { ProjectConfig } from "../Models/ProjectConfig.js"

export class GetConfigProjectUseCase implements UseCase<void, ProjectConfig> {
  static create({ config }: { config: Config }) {
    return new GetConfigProjectUseCase(GetConfigProjectService.create({ config }))
  }

  constructor(private readonly service: GetConfigProjectService) {}

  async execute(): Promise<ProjectConfig> {
    const config = await this.service.execute()

    return config
  }
}
